import { useState, useEffect, useCallback } from 'react';

export function useSearchParams(): [
  URLSearchParams | undefined,
  (params: URLSearchParams | Record<string, string>, options?: { replace?: boolean }) => void,
] {
  const [searchParams, setSearchParamsState] = useState<URLSearchParams | undefined>(() => {
    if (typeof URLSearchParams !== 'undefined') {
      return new URLSearchParams(window.location.search);
    }

    return;
  });

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const onPopState = (): void => {
      setSearchParamsState(new URLSearchParams(window.location.search));
    };

    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const setSearchParams = useCallback((init: URLSearchParams | Record<string, string>, options?: { replace?: boolean }) => {
    if (typeof window === 'undefined') {
      return;
    }

    const nextParams = new URLSearchParams(init as Record<string, string> | string);
    const queryString = nextParams.toString();

    const url = window.location.pathname + (queryString ? `?${queryString}` : '') + window.location.hash;

    if (options?.replace) {
      window.history.replaceState(null, '', url);
    } else {
      window.history.pushState(null, '', url);
    }

    setSearchParamsState(nextParams);
  }, []);

  return [searchParams, setSearchParams];
}
